import boltIcon from '../assets/images/bolt.svg';
import infoIcon from '../assets/images/info_icon.svg';
import discountIcon from '../assets/images/discount.svg';
import logoutIcon from '../assets/images/heroicons-solid_logout.svg';
import onlineNavIcon from '../assets/images/online_icon.svg';
import superAgiIcon from '../assets/images/superagi-text.svg';
import discordIcon from '../assets/images/discord.svg';
import superAgiText from '../assets/images/superagi-text.svg';
import manage_billing from '../assets/images/normal/manage_billing.svg';
import selected_manage_billing from '../assets/images/selected/manage_billing.svg';
import software_credits from '../assets/images/normal/software_credits.svg';
import selected_software_credits from '../assets/images/selected/software_credits.svg';
import payment_methods from '../assets/images/normal/payment_methods.svg';
import invoices from '../assets/images/normal/invoices.svg';
import selected_invoices from '../assets/images/selected/invoices.svg';
import worker_activity from '../assets/images/normal/worker_activity.svg';
import selected_worker_activity from '../assets/images/selected/worker_activity.svg';
import open_in_new from '../assets/images/open_in_new.svg';
import sortingArrow from '../assets/images/sorting_arrow.svg';
import sortingArrowSelected from '../assets/images/sorting_arrow_selected.svg';
import leftArrowIcon from '../assets/images/left_arrow.svg';
import rightArrowIcon from '../assets/images/right_arrow.svg';
import verified from '../assets/images/verified.svg';
import moreIconVerticalDisabled from '../assets/images/more_icon_vertical_disabled.svg';
import moreIconVertical from '../assets/images/more_icon_vertical.svg';
import statusBullet from '../assets/images/status_bullet.svg';
import closeIcon from '../assets/images/close_icon.svg';
import whiteDot from '../assets/images/white_dot.svg';
import arrowDownTooltip from '../assets/images/arrow_down_tooltip.svg';
import profileIconPlaceholder from '../assets/images/profile_icon_placeholder.svg';
import products_admin from '../assets/images/normal/products_admin.svg';
import selected_products_admin from '../assets/images/selected/products_admin.svg';
import emptyScreen from '../assets/images/empty_screen.svg';
import downloadIcon from '../assets/images/download_icon.svg';
import removeIcon from '../assets/images/remove.svg';
import check from '../assets/images/check.svg';
import workspaceFilled from '../assets/images/normal/workspace_filled.svg';
import workspaceEmpty from '../assets/images/normal/workspace_empty.svg';
import addIcon from '../assets/images/add.svg';
import previewIcon from '../assets/images/preview.svg';
import coinIcon from '../assets/images/coin.svg';
import minusIcon from '../assets/images/minus_icon.svg';
import greyTickCircle from '../assets/images/grey_tick_circle.svg';
import greenTickCircle from '../assets/images/green_tick_circle.svg';
import downArrowBlackIcon from '../assets/images/down_arrow_black_icon.svg';
import cancelGreyCircleIcon from '../assets/images/cancel_grey_circle_icon.svg';
import emailPinkIcon from '../assets/images/email_pink_icon.svg';
import phonePinkIcon from '../assets/images/phone_pink_icon.svg';
import marketResearchPinkIcon from '../assets/images/market_research_pink_icon.svg';
import signalPinkIcon from '../assets/images/signal_pink_icon.svg';
import pokerPinkIcon from '../assets/images/poker_pink_icon.svg';
import dragIconGrey from '../assets/images/drag_icon_grey.svg';
import questionMark from '../assets/images/question_mark.svg';
import clockIcon from '../assets/images/clock_icon.svg';
import lockIcon from '../assets/images/lock_icon.svg';
import warningIcon from '../assets/images/warning_icon.svg';
import downArrowWhiteIcon from '../assets/images/down_arrow_white.svg';
import searchIconGrey from '../assets/images/search_icon_grey.svg';
import visaIcon from '../assets/images/cards/visa.svg';
import mastercardIcon from '../assets/images/cards/mastercard.svg';
import amexIcon from '../assets/images/cards/amex.svg';
import discoverIcon from '../assets/images/cards/discover.svg';
import unknownIcon from '../assets/images/cards/unknown.svg';

export default {
  lockIcon,
  downArrowWhiteIcon,
  searchIconGrey,
  clockIcon,
  questionMark,
  dragIconGrey,
  pokerPinkIcon,
  emailPinkIcon,
  signalPinkIcon,
  marketResearchPinkIcon,
  phonePinkIcon,
  cancelGreyCircleIcon,
  downArrowBlackIcon,
  greenTickCircle,
  greyTickCircle,
  minusIcon,
  workspaceFilled,
  check,
  workspaceEmpty,
  verified,
  infoIcon,
  closeIcon,
  addIcon,
  removeIcon,
  downloadIcon,
  emptyScreen,
  products_admin,
  selected_products_admin,
  arrowDownTooltip,
  profileIconPlaceholder,
  boltIcon,
  whiteDot,
  moreIconVertical,
  statusBullet,
  moreIconVerticalDisabled,
  leftArrowIcon,
  rightArrowIcon,
  sortingArrow,
  sortingArrowSelected,
  logoutIcon,
  discountIcon,
  onlineNavIcon,
  superAgiIcon,
  discordIcon,
  superAgiText,
  manage_billing,
  selected_manage_billing,
  software_credits,
  selected_software_credits,
  payment_methods,
  invoices,
  selected_invoices,
  worker_activity,
  selected_worker_activity,
  open_in_new,
  previewIcon,
  coinIcon,
  warningIcon,
  visaIcon,
  mastercardIcon,
  amexIcon,
  discoverIcon,
  unknownIcon,
};
